module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "center navWrapper"
  }, [_c('app-header', {
    attrs: {
      "isBetaUser": _vm.settings.betaUser
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "center wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "component-fade",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    attrs: {
      "categories": _vm.categories,
      "days": _vm.days
    }
  })], 1)], 1), _vm._v(" "), _c('category-modal', {
    attrs: {
      "show": _vm.showCategoryModal,
      "categories": _vm.categories
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9f3fcbf0!./~/vue-loader/lib/selector.js?type=template&index=0!./dev/src/App.vue
// module id = ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-9f3fcbf0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./dev/src/App.vue
// module chunks = 0